import {
  LoadManager, PageHeader, Styles,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import clinicalCares from '@/services/api/clinicalCares'
import React from 'react'
import { Link } from 'react-router-dom'
import Row from './components/CountRow/index'
import mapStatus from './components/CountRow/mapStatus'

function ClinicalCares({ title }) {
  usePageTitle({ title })
  const {
    loading, data, error,
  } = useAxiosRequest(clinicalCares.countStatus)

  const list = data
    ?.map((item) => ({ ...item, ...mapStatus(item.status) }))
    ?.sort((a, b) => a.sequence - b.sequence)

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Atendimentos clínicos"
        icon="fas fa-stethoscope"
        subtitle="Totais de atendimentos clínicos por status"
        rightAction={() => (
          <Link to="/app/clinical-cares/form/add" className="btn btn-primary">
            <i className="fas fa-plus" />
            &nbsp;Adicionar
          </Link>
        )}
      />
      <LoadManager loading={loading} error={error}>
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Status</th>
              <th width="130px">Quantidade</th>
              <th width="1">Ações</th>
            </tr>
          </thead>
          <tbody>
            {list?.map((item) => <Row key={item.status} item={item} />)}
          </tbody>
        </table>
      </LoadManager>
    </Styles.Container>
  )
}

export default ClinicalCares
